import { render, staticRenderFns } from "./ed-courses.vue?vue&type=template&id=1e7a1f8b&scoped=true&"
import script from "./ed-courses.ts?vue&type=script&lang=ts&"
export * from "./ed-courses.ts?vue&type=script&lang=ts&"
import style0 from "./ed-courses.scss?vue&type=style&index=0&id=1e7a1f8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7a1f8b",
  null
  
)

export default component.exports